/*
  PRP cart free shipping progress bar.

  Why this is JS rather than Liquid inside the drawer:
  snippets/cart-drawer.liquid is a 36KB file and the Shopify API can only write
  whole files, so inserting two lines there means retyping the entire drawer.
  This injects into .drawer__inner instead, which is the element the theme
  replaces on every cart update, and re-injects itself whenever that happens.

  Threshold is set in layout/theme.liquid, not here.

  AUSTRALIA ONLY. The free shipping rate exists on the Domestic zone only; the
  International zone is a flat $34.95 with no threshold. So the bar carries an
  "Australia only" note, and is withheld entirely from buyers whose country is
  known and is not AU, because showing someone in Auckland a countdown to an
  offer they cannot receive is worse than showing nothing.

  Two states:
  - Cart has items: progress bar counting down to the threshold.
  - Cart empty: a plain line stating the offer, since there is no progress to
    show but the offer is still worth knowing before they start shopping.
*/
(function () {
  var BAR_CLASS = 'prp-fsb';
  var isSyncing = false;

  var TRUCK_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M1 3h13v13H1z"/>' +
    '<path d="M14 8h4l3 3v5h-7z"/>' +
    '<circle cx="5.5" cy="18.5" r="2.5"/>' +
    '<circle cx="17.5" cy="18.5" r="2.5"/>' +
    '</svg>';

  function config() {
    return document.querySelector('[data-free-shipping-config]');
  }

  function thresholdCents() {
    var el = config();
    if (!el) return null;
    var value = parseInt(el.getAttribute('data-threshold-cents'), 10);
    return isNaN(value) || value <= 0 ? null : value;
  }

  /* Only withhold when the country is known and is not AU. An empty or missing
     value means markets are not resolving a country, and in that case showing
     the message with its note is the safer default. */
  function eligible() {
    var el = config();
    if (!el) return false;
    var country = (el.getAttribute('data-country') || '').trim().toUpperCase();
    if (!country) return true;
    return country === 'AU';
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* Whole dollars read better in a standing offer line: "over $175", not
     "over $175.00". Cents are kept for the countdown, where they are exact. */
  function roundMoney(cents) {
    return cents % 100 === 0 ? '$' + cents / 100 : money(cents);
  }

  function drawerInner() {
    return document.querySelector('cart-drawer .drawer__inner');
  }

  function buildBar() {
    var bar = document.createElement('div');
    bar.className = BAR_CLASS;
    bar.setAttribute('data-prp-fsb', '');
    bar.innerHTML =
      '<p class="' + BAR_CLASS + '__text"></p>' +
      '<div class="' + BAR_CLASS + '__meter">' +
      '<div class="' + BAR_CLASS + '__track">' +
      '<div class="' + BAR_CLASS + '__fill"></div>' +
      '</div>' +
      '<span class="' + BAR_CLASS + '__icon">' + TRUCK_SVG + '</span>' +
      '</div>' +
      '<p class="' + BAR_CLASS + '__note">Australia only</p>';
    return bar;
  }

  /* Place the bar directly under the drawer heading where possible, so it reads
     as part of the cart summary rather than floating above the line items. */
  function insertBar(inner) {
    var bar = buildBar();
    var header = inner.querySelector('.drawer__header');
    if (header && header.parentNode === inner) {
      header.insertAdjacentElement('afterend', bar);
    } else {
      inner.insertBefore(bar, inner.firstChild);
    }
    return bar;
  }

  function paint(bar, totalCents, threshold) {
    var text = bar.querySelector('.' + BAR_CLASS + '__text');
    var fill = bar.querySelector('.' + BAR_CLASS + '__fill');
    if (!text || !fill) return;

    var remaining = threshold - totalCents;

    if (remaining <= 0) {
      bar.classList.add('is-unlocked');
      text.textContent = 'Free shipping unlocked';
      fill.style.width = '100%';
      return;
    }

    bar.classList.remove('is-unlocked');
    text.innerHTML =
      'Spend <span class="' + BAR_CLASS + '__amount"></span> more for free shipping';
    text.querySelector('.' + BAR_CLASS + '__amount').textContent = money(remaining);
    fill.style.width = Math.max(2, (totalCents / threshold) * 100) + '%';
  }

  /* Empty cart. Sits under the "Your cart is empty" heading, above the log in
     line, so the offer is the first thing read after the bad news. */
  function paintEmpty(threshold) {
    var host = document.querySelector('cart-drawer .cart-drawer__empty-content');
    if (!host) return;

    var existing = host.querySelector('[data-prp-fsb-empty]');
    if (existing) return;

    var note = document.createElement('p');
    note.className = BAR_CLASS + '-empty';
    note.setAttribute('data-prp-fsb-empty', '');
    note.innerHTML =
      '<span class="' + BAR_CLASS + '-empty__icon">' + TRUCK_SVG + '</span>' +
      '<span>Free shipping on Australian orders over <strong></strong></span>';
    note.querySelector('strong').textContent = roundMoney(threshold);

    var heading = host.querySelector('.cart__empty-text');
    if (heading) {
      heading.insertAdjacentElement('afterend', note);
    } else {
      host.appendChild(note);
    }
  }

  function clearEmpty() {
    var note = document.querySelector('cart-drawer [data-prp-fsb-empty]');
    if (note) note.remove();
  }

  function sync() {
    if (isSyncing) return;

    var threshold = thresholdCents();
    if (threshold === null) return;

    if (!eligible()) {
      var staleBar = document.querySelector('cart-drawer [data-prp-fsb]');
      if (staleBar) staleBar.remove();
      clearEmpty();
      return;
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart fetch failed');
        return response.json();
      })
      .then(function (cart) {
        isSyncing = true;

        var bar = document.querySelector('cart-drawer [data-prp-fsb]');

        if (!cart || cart.item_count === 0) {
          if (bar) bar.remove();
          paintEmpty(threshold);
          return;
        }

        clearEmpty();

        var currentInner = drawerInner();
        if (!currentInner) return;

        if (!bar) bar = insertBar(currentInner);
        paint(bar, cart.total_price, threshold);
      })
      .catch(function () {
        /* Fail quiet. A missing progress bar is a non-event; a broken cart is not. */
      })
      .then(function () {
        window.requestAnimationFrame(function () {
          isSyncing = false;
        });
      });
  }

  function watch() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    sync();

    /* The theme replaces the drawer contents wholesale on every cart change,
       which wipes whichever state is showing. Watching the subtree covers add,
       remove, and quantity changes without hooking into the theme's own
       cart classes. */
    var observer = new MutationObserver(function () {
      if (isSyncing) return;
      sync();
    });

    observer.observe(drawer, { childList: true, subtree: true });

    /* Opening the drawer does not always mutate it, so catch that separately. */
    var openObserver = new MutationObserver(function () {
      if (drawer.classList.contains('active')) sync();
    });
    openObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
